import { SLASH } from '@lacele/const'
import joinStrings from '../joinStrings'

export default function (...args) {
    return joinStrings(SLASH, ...args)
}
